// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"305":"7a0716a1","453":"38c68d19","458":"987135cc","638":"80f8b3d5","770":"33314c43","868":"16de5194"}[chunkId] + ".chunk.js";
};